import script from "./CSaFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./CSaFooter.vue?vue&type=script&setup=true&lang=js"

import "./CSaFooter.vue?vue&type=style&index=0&id=32086b92&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32086b92"]])

export default __exports__